import { useGet } from "../api-client/useGet";
import { LeadFormData, LeadParams } from "../blocks/LeadForm/LeadFormModal";
import { useLanguage } from "../i18n/useLanguage";
import { useCart } from "../stores/hooks/useCart";
import { useSetInfoToast } from "../stores/hooks/useSetInfoToast";

type CreateQuoteContactLead = (params: LeadParams) => Promise<LeadFormData>;

export const useCreateQuoteContactLead = (): CreateQuoteContactLead => {
  const { get } = useGet();
  const cart = useCart();
  const [language] = useLanguage();
  const setInfoToast = useSetInfoToast();

  const createQuoteContactLead = async ({
    customerEmail,
    customerFirstName,
    customerLastName,
    customerMessage,
    customerPhone,
    customerVin,
    generatedBy,
    sendCustomerEmail,
  }: LeadParams): Promise<LeadFormData> => {
    await get(
      `/retailSiteWebService/shopping/lead/createQuoteContactLead.php`,
      {
        customerEmail,
        customerFirstName,
        customerLanguage: language,
        customerLastName,
        customerMessage,
        customerPhone,
        customerVin,
        generatedBy,
        orderNumber: String(cart?.orderNumber),
        sendCustomerEmail: String(sendCustomerEmail),
        targetDealerId: String(cart?.dealerId),
      }
    );
    if (sendCustomerEmail) {
      setInfoToast({ message: "leadForm.successMessage" });
    }

    return {
      customerEmail,
      customerFirstName,
      customerLastName,
      customerMessage,
      customerPhone,
      customerVin,
      generatedBy,
    };
  };
  return createQuoteContactLead;
};
